import { Observable } from "rxjs";
import { IChatSetting } from "@listat/r2-core";
import { IQuickAction, ISkill } from "@core/base/chat-setting-base";
import {
    OfficeChatSettingAdapterV1
} from "./office-chat-setting-v1/office-chat-setting-adapter-v1";
import { ChatSettingBase } from "@core/base/chat-setting-base";
import { OfficeChatSettingBase } from "@core/office/office-chat-setting/office-chat-setting-base";
import { OfficeService } from "@core/office/office-service/office-service";
import { OfficeSessionService } from "@core/office/office-session/office.session.service";
import { OfficeChatRepository } from "@core/office/office-chat-repository/office-chat-repository";

export class OfficeChatSetting extends ChatSettingBase implements ChatSettingBase {
    private officeChatSetting: OfficeChatSettingBase = new OfficeChatSettingAdapterV1(
        this.office,
        this.session,
        this.chatRepository
    );

    constructor(
        private office: OfficeService,
        private session: OfficeSessionService,
        private chatRepository: OfficeChatRepository,
    ) {
        super();
    }

    public $getSetting(): Observable<IChatSetting> {
        return this.officeChatSetting.$getSetting()
    }

    public getSetting(): IChatSetting {
        return this.officeChatSetting.getSetting()
    }

    public setSetting(setting: IChatSetting): IChatSetting {
        return this.officeChatSetting.setSetting(setting)
    }

    public getSettingOriginal<T>(): T {
        return this.officeChatSetting.getSettingOriginal<T>();
    }

    public getQuickActionsDefault(): IQuickAction[] {
        return this.officeChatSetting.getQuickActionsDefault()
    }

    public $getQuickActions(): Observable<IQuickAction[]> {
        return this.officeChatSetting.$getQuickActions()
    }

    public setQuickActions(newActions: IQuickAction[]): IQuickAction[] {
        return this.officeChatSetting.setQuickActions(newActions);
    }

    public $getSkills(): Observable<ISkill[]> {
        return this.officeChatSetting.$getSkills()
    }

    public setSkills(newSkills: ISkill[]): ISkill[] {
        return this.officeChatSetting.setSkills(newSkills);
    }

    public override onDestroy(): void {
        this.officeChatSetting.onDestroy()
    }
}
